import { useMemo } from 'react';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import {
  PosMultiSelect,
  PosMultiSelectProps,
} from 'src/core/POS/PosMultiSelect';

type VenueSelectorProps = Omit<PosMultiSelectProps, 'valueOptionsContent'> & {
  forceUseCatalogV2?: boolean;
};

export const PerformerSelector = ({
  forceUseCatalogV2,
  ...props
}: VenueSelectorProps) => {
  const { data: catalogData, isLoading } = useCatalogDataContext();

  const { allPerformers, allPerformerSort } = useMemo(() => {
    if (!catalogData?.events) {
      return {
        allPerformers: {},
        allPerformerSort: {},
      };
    }

    const allPerformers = {} as Record<string, string>;
    const allPerformerSort = {} as Record<string, string>;

    Object.values(catalogData.performers).forEach((performer) => {
      if (performer && performer.viagId) {
        allPerformers[performer.viagId] = performer.name;

        allPerformerSort[performer.viagId] = performer.name;
      }
    });

    return { allPerformers, allPerformerSort };
  }, [catalogData]);

  return (
    <PosMultiSelect
      {...props}
      searchable
      loading={isLoading}
      useVirtualWindow
      valueOptionsContent={allPerformers}
      valueOptionsSort={allPerformerSort}
      sortMode="ascending"
    />
  );
};
